// tslint:disable:max-line-length

import React from 'react';

export const StatusLocked = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path
        transform="translate(2 1)"
        d="M10,6H8V4c0-1.1-0.9-2-2-2C4.9,2,4,2.9,4,4v2H2V4c0-2.2,1.8-4,4-4s4,1.8,4,4V6zM0,14h12V6H0V14z"
      />
    </svg>
  );
};
